import React from 'react';

import { PropertyType } from '@ha/algolia';

import { getIsNorthAmericanCountryName } from 'ha/utilities/isNorthAmerican';
import { getAreaLabel } from 'ha/utilities/unitConverter';

import { ListingCardModel } from 'ha/models/Listing/types';

import { ListingCardDetailsAttribute } from './ListingCardDetailsAttributes';

interface ListingCardDetailsAttributesSizeProps {
  listing: ListingCardModel;
}

export const shouldShowListingCardDetailsAttributesSize = (
  listing: ListingCardDetailsAttributesSizeProps['listing'],
) => {
  const shouldShowBedroomSize =
    listing.space.propertyType === PropertyType.privateRoom ||
    listing.space.propertyType === PropertyType.sharedRoom;

  if (!shouldShowBedroomSize && !listing.space.totalSizeSqm) {
    return false;
  }

  if (shouldShowBedroomSize && !listing.space.bedroomSizeSqm) {
    return false;
  }

  return true;
};

export const ListingCardDetailsAttributesSize = React.memo(
  ({ listing }: ListingCardDetailsAttributesSizeProps) => {
    const shouldUseImperialSystem = getIsNorthAmericanCountryName(
      listing.location.country.en,
    );

    const shouldShowBedroomSize =
      listing.space.propertyType === PropertyType.privateRoom ||
      listing.space.propertyType === PropertyType.sharedRoom;

    if (!shouldShowListingCardDetailsAttributesSize(listing)) {
      return null;
    }

    return (
      <ListingCardDetailsAttribute
        slots={{
          icon: null,
          label: shouldShowBedroomSize
            ? getAreaLabel(
                listing.space.bedroomSizeSqm?.toString(),
                shouldUseImperialSystem,
              )
            : getAreaLabel(
                listing.space.totalSizeSqm?.toString(),
                shouldUseImperialSystem,
              ),
        }}
        data-test-locator="ListingCard/AttributesSize"
      />
    );
  },
);
